import React, { memo } from 'react';

interface ApplicationHeaderProps {
  status: 'pending' | 'approved' | 'rejected' | 'checked' | 'consumed';
  waitingPosition: number | null;
  isEditing: boolean;
  onEdit: () => void;
}

const ApplicationHeaderComponent: React.FC<ApplicationHeaderProps> = ({
  status,
  waitingPosition,
  isEditing,
  onEdit
}) => {
  const isWaitingStatus = status === 'pending' || status === 'checked';
  return (
    <div className="mt-4 md:mt-8">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-0">
        <div className="text-slate-800 text-2xl md:text-4xl font-extrabold font-['Pretendard'] leading-9">
          신청이 완료되었습니다
        </div>
        {isWaitingStatus && waitingPosition != null && (
          <div className="px-3 md:px-4 py-1.5 bg-[#f2f6fb] rounded-[5px] inline-flex items-center gap-2 md:gap-2.5 self-start md:self-auto">
            <div className="w-5 h-5 md:w-6 md:h-6 relative flex-shrink-0">
              <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#42506e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 6V12L16 14" stroke="#42506e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span className="text-[#42506e] text-sm md:text-lg font-medium whitespace-nowrap">현재 대기 순번</span>
            <span className="text-[#1b89e5] text-sm md:text-lg font-bold whitespace-nowrap">{waitingPosition}번</span>
          </div>
        )}
      </div>
      <div className="w-full h-px mt-4 md:mt-8 outline outline-1 outline-offset-[-0.50px] outline-neutral-200"></div>
      <div className="mt-4 md:mt-8 flex items-center justify-between">
        <div className="text-[#1e2c49] text-xl md:text-2xl font-bold font-['Pretendard'] leading-9">
          입주 신청 내역
        </div>
        {status === 'pending' && !isEditing && (
          <button
            onClick={onEdit}
            className="w-24 md:w-[130px] h-10 md:h-11 bg-[#155acb] text-white text-sm md:text-base font-bold rounded-sm hover:bg-[#155acb]/90 transition-colors"
          >
            수정하기
          </button>
        )}
      </div>
    </div>
  );
};

export const ApplicationHeader = memo(ApplicationHeaderComponent);
